import type { JSXElement } from "solid-js"

export default function SmallTextMuted (text : JSXElement) {
  return <span class="small text-muted">{text}</span>
}
